<template>
  <div class="resolved-thread-bar" data-testid="resolved-thread-bar">
    <v-icon class="resolved-thread-bar__icon" size="16" color="#067647">
      mdi-check-circle-outline
    </v-icon>
    <span class="resolved-thread-bar__text" data-testid="resolved-thread-bar-text">
      {{ summary }}
    </span>
    <button
      v-if="replyCount > 0"
      type="button"
      class="resolved-thread-bar__button resolved-thread-bar__button--toggle"
      :aria-expanded="String(expanded)"
      data-testid="resolved-thread-bar-toggle"
      @click="emit('toggle')"
    >
      {{ toggleLabel }}
    </button>
    <button
      type="button"
      class="resolved-thread-bar__button"
      data-testid="resolved-thread-bar-reopen"
      @click="emit('reopen')"
    >
      Reopen
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  replyCount: { type: Number, default: 0 },
  /** Name of the person who resolved the thread, when the API provides it. */
  resolvedBy: { type: String, default: "" },
  /** Pre-formatted resolve date, e.g. "Oct 10, 2026". */
  resolvedOn: { type: String, default: "" },
  expanded: { type: Boolean, default: false },
});

const emit = defineEmits(["toggle", "reopen"]);

const summary = computed(() => {
  const head = props.resolvedBy ? `Resolved by ${props.resolvedBy}` : "Resolved";
  return props.resolvedOn ? `${head} · ${props.resolvedOn}` : head;
});

const toggleLabel = computed(() => {
  if (props.expanded) return "Hide replies";
  return `Show ${props.replyCount} ${props.replyCount === 1 ? "reply" : "replies"}`;
});
</script>

<style scoped>
.resolved-thread-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 8px 12px;
  border: 1px solid #abefc6;
  border-radius: 8px;
  background: #ecfdf3;
  box-sizing: border-box;
}

.resolved-thread-bar__text {
  flex: 1;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #067647;
}

.resolved-thread-bar__button {
  padding: 0;
  border: none;
  background: transparent;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: #344054;
  cursor: pointer;
}

.resolved-thread-bar__button--toggle {
  color: #067647;
}

.resolved-thread-bar__button:hover {
  text-decoration: underline;
}

.resolved-thread-bar__button:focus-visible {
  outline: 2px solid #344054;
  outline-offset: 2px;
  border-radius: 2px;
}
</style>
